import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JurisdictionBoundaryImportsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type JurisdictionBoundaryImportsSubscription = { __typename?: 'subscription_root', jurisdiction_boundary_imports: Array<{ __typename?: 'jurisdiction_boundary_imports', id: any, source: string, layer_url: string, status: string, feature_count: number, loaded_count: number, superseded_count: number, unchanged_count: number, renumbered_count: number, failed_count: number, proposed_count: number, error_message?: string | null, name_field?: string | null, id_field?: string | null, county_field?: string | null, authority_fields?: any | null, effective_from: any, started_at?: any | null, completed_at?: any | null, created_at: any, jurisdiction_type: { __typename?: 'jurisdiction_types', id: any, code: string, name: string } }> };


export const JurisdictionBoundaryImportsDocument = gql`
    subscription jurisdictionBoundaryImports {
  jurisdiction_boundary_imports(order_by: {created_at: desc}, limit: 25) {
    id
    source
    layer_url
    status
    feature_count
    loaded_count
    superseded_count
    unchanged_count
    renumbered_count
    failed_count
    proposed_count
    error_message
    name_field
    id_field
    county_field
    authority_fields
    effective_from
    started_at
    completed_at
    created_at
    jurisdiction_type {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useJurisdictionBoundaryImportsSubscription__
 *
 * To run a query within a React component, call `useJurisdictionBoundaryImportsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useJurisdictionBoundaryImportsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJurisdictionBoundaryImportsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useJurisdictionBoundaryImportsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<JurisdictionBoundaryImportsSubscription, JurisdictionBoundaryImportsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<JurisdictionBoundaryImportsSubscription, JurisdictionBoundaryImportsSubscriptionVariables>(JurisdictionBoundaryImportsDocument, options);
      }
export type JurisdictionBoundaryImportsSubscriptionHookResult = ReturnType<typeof useJurisdictionBoundaryImportsSubscription>;
export type JurisdictionBoundaryImportsSubscriptionResult = Apollo.SubscriptionResult<JurisdictionBoundaryImportsSubscription>;